import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
 
@Injectable({
  providedIn: 'root'
})
export class CartHeadResolverService implements Resolve<any> {
  constructor(
    private _apiSvc: ApiService,
    private router: Router
    ) {}

  private _cartItemEp = `${this._apiSvc.endpoints.sales}/api/Cart`;

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const navigationState = this.router.getCurrentNavigation()?.extras?.state;
    if (!navigationState) {
      return this._apiSvc.get(`${this._cartItemEp}/${route.paramMap.get('cartId')}`)
      .pipe(catchError(() => {
        return EMPTY;
      }));
    }
    else {
      return of(EMPTY);
    }
  }
}
